// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"fbe42fad","787":"7875cb58"}[chunkId] + ".chunk.js";
};